import * as THREE from 'three';

const BAR_WIDTH = 2.8;
const BAR_HEIGHT = 0.3;
const FRAME_PADDING = 0.08;
const FRAME_COLOR = 0x0a0d18;
const FILL_BG_COLOR = 0x1f2536;

const _tmpColor = new THREE.Color();

export class NpcHealthBar {
  readonly object3D: THREE.Group;
  private readonly fillMesh: THREE.Mesh;
  private readonly fillMaterial: THREE.MeshBasicMaterial;

  constructor() {
    this.object3D = new THREE.Group();
    this.object3D.name = 'npc-health-bar';
    this.object3D.renderOrder = 999;

    const frameGeo = new THREE.PlaneGeometry(
      BAR_WIDTH + FRAME_PADDING,
      BAR_HEIGHT + FRAME_PADDING
    );
    const frameMat = new THREE.MeshBasicMaterial({
      color: FRAME_COLOR,
      transparent: true,
      opacity: 0.7,
      depthWrite: false,
      depthTest: false,
      toneMapped: false
    });
    const frame = new THREE.Mesh(frameGeo, frameMat);
    frame.renderOrder = 999;

    const bgGeo = new THREE.PlaneGeometry(BAR_WIDTH, BAR_HEIGHT);
    const bgMat = new THREE.MeshBasicMaterial({
      color: FILL_BG_COLOR,
      transparent: true,
      opacity: 0.85,
      depthWrite: false,
      depthTest: false,
      toneMapped: false
    });
    const bg = new THREE.Mesh(bgGeo, bgMat);
    bg.position.z = 0.001;
    bg.renderOrder = 1000;

    const fillGeo = new THREE.PlaneGeometry(BAR_WIDTH, BAR_HEIGHT);
    fillGeo.translate(BAR_WIDTH / 2, 0, 0);
    this.fillMaterial = new THREE.MeshBasicMaterial({
      color: 0x7bff6a,
      transparent: true,
      opacity: 0.95,
      depthWrite: false,
      depthTest: false,
      toneMapped: false
    });
    this.fillMesh = new THREE.Mesh(fillGeo, this.fillMaterial);
    this.fillMesh.position.set(-BAR_WIDTH / 2, 0, 0.002);
    this.fillMesh.renderOrder = 1001;

    this.object3D.add(frame, bg, this.fillMesh);
  }

  setRatio(ratio: number): void {
    const clamped = Math.max(0, Math.min(1, ratio));
    this.fillMesh.scale.x = clamped === 0 ? 0.0001 : clamped;
    if (clamped > 0.55) {
      _tmpColor.setRGB(0.35, 0.95, 0.4);
    } else if (clamped > 0.25) {
      _tmpColor.setRGB(0.98, 0.82, 0.25);
    } else {
      _tmpColor.setRGB(0.95, 0.32, 0.32);
    }
    this.fillMaterial.color.copy(_tmpColor);
  }

  positionAbove(
    shipPos: THREE.Vector3,
    offsetY: number,
    cameraQuaternion: THREE.Quaternion
  ): void {
    this.object3D.position.set(shipPos.x, shipPos.y + offsetY, shipPos.z);
    this.object3D.quaternion.copy(cameraQuaternion);
  }

  dispose(): void {
    this.object3D.traverse((node) => {
      if (node instanceof THREE.Mesh) {
        node.geometry.dispose();
        const mat = node.material;
        if (Array.isArray(mat)) mat.forEach((m) => m.dispose());
        else mat.dispose();
      }
    });
  }
}
